import React from 'react'
import _ from 'lodash'

import Button from 'Design/components/Button'
import GetStartedImg from 'Images/onboarding_get_started.svg'

import styles from './OnboardingGetStarted.module.css'

const OnboardingGetStarted = (props) => {
  const { onSkipOnBoarding, onGetStarted, name } = props

  return (
    <div className={styles.OnboardingGetStarted}>
      <div className={styles.ImageContainer}>
        <GetStartedImg className={styles.GetStartedImg} />
      </div>
      <div className={styles.TextContainer}>
        <div className={styles.WelcomeName}> Welcome {_.capitalize(name)}! </div>
        <div className={styles.Title}> Build Custom Chatbots </div>
        <div className={styles.BtnGroup}>
          <Button variant='primary' className={styles.GetStarted} onClick={onGetStarted}>
            Get started
          </Button>
          <label className={styles.SkipLabel} onClick={onSkipOnBoarding}>
            Skip for now
          </label>
        </div>
      </div>
    </div>
  )
}

export default OnboardingGetStarted
